import axios from './providers/axios';

const userService = {
    getUsers(page, filters = []) {
        const params = {
            limit: 20,
            page: page
        };

        if (filters && filters.length > 0) {
            filters.forEach((filter) => {
                params[filter.key] = filter.value;
            });
        }

        return axios.get('/v1/admin/user/store', { params });
    },

    getCompanyUsers(page, company, filters = [], searchText = '', limit = 20) {
        const params = {
            limit: limit,
            page: page,
            companyId: company
        };

        if (searchText) {
            params.searchText = searchText;
        }

        if (filters && filters.length > 0) {
            filters.forEach((filter) => {
                params[filter.key] = filter.value;
            });
        }

        return axios.get('/v1/admin/user/store', { params });
    },

    getUserDetails(id) {
        return axios.get(`/v1/admin/user/getFromDetail/${id}`);
    },

    getOnboardingDetail(userId) {
        return axios.get(`/v1/admin/user/getOnboardingDetail?userId=${userId}`);
    },

    addUser(data) {
        return axios.post('/v1/admin/user/add', data, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        });
    },

    editUser(data) {
        return axios.post('/v1/admin/user/update', data, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        });
    },

    deleteUser(id) {
        return axios.delete(`/v1/admin/user/delete/${id}`);
    },

    getDetailLogs(lang, id, page = 1, limit = 20){
        return axios.get(`/v1/admin/user/getLogsByUserId/${id}?page=${page}&limit=${limit}`, {
            headers:{
                "Accept-Language": lang,
            }
        });
    },

    assignDepartmentToUsers(data) {
        return axios.post('/v1/admin/user/assignToDepartment', data, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        });
    },

    exportUsers(filters = []) {
        const params = {
            list: true
        };

        if (filters && filters.length > 0) {
            filters.forEach((filter) => {
                params[filter.key] = filter.value;
            });
        }

        return axios.post('/v1/admin/user/export', params, {
            responseType: 'arraybuffer'
        });
    }
}

export default userService;
